import React from "react";

const EditableRow = ({
  editFormData,
  handleEditFormChange,
  handleCancelClick,
}) => {
  return (
    <tr>
      <td>
        <input
          type="text"
          name="department_name"
          value={editFormData.department_name}
          onChange={handleEditFormChange}
          required
        />
      </td>
      <td>
        <button type="submit">Save</button>&nbsp; &nbsp;
        <button type="button" onClick={handleCancelClick}>
          Cancel
        </button>
      </td>
    </tr>
  );
};

export default EditableRow;
